import React, { useEffect, useState } from 'react';
import AdContainer from 'src/components/ads';
import { MobileOnly } from 'src/ui/block';
import { useMobileTopAdExperiment } from 'src/hooks/experiments';

export const MobileTopAd: React.FC = () => {
  const experiment = useMobileTopAdExperiment();
  const [showMobileAd, setShowMobileAd] = useState<boolean>(false);

  useEffect(() => setShowMobileAd(experiment), [experiment]);

  return showMobileAd ? (
    <MobileOnly>
      <AdContainer
        placement="dubbelpanorama_top"
        min={0}
        max={860}
        format="toppanorama"
        spacing={{ top: '10px' }}
      />
    </MobileOnly>
  ) : null;
};
